/**
 * Svenska Skidförbundets IronMan fystest (SENIOR) — the 8 events, the capacity
 * each measures, and which part of the plan develops it. Used by the IronMan
 * panel to show per-event targeting and to track current vs. target results.
 * Source: IronMan-Testprotokoll 2024.1 (see memory ironman-fystest).
 *
 * Results are stored locally (no official point tables yet — those live on PDF
 * pages ~10–26 and would be a follow-up).
 */

export interface IronManEvent {
  id: string;
  name: string;
  capacity: string;      // what it measures
  unit: string;          // how a result is entered (hint)
  trainedBy: string;     // which sessions/phase develop it
  higherIsBetter: boolean; // for framing progress (time events: lower is better)
}

export const IRONMAN_EVENTS: IronManEvent[] = [
  { id: "run3000",   name: "3000 meter",        capacity: "Aerob kapacitet",        unit: "tid mm:ss", higherIsBetter: false,
    trainedBy: "Kvalitetslöpning (tröskel/VO2max) + lugn löpning" },
  { id: "hexagon",   name: "Hexagon",           capacity: "Koordination / snabbhet", unit: "tid sek",   higherIsBetter: false,
    trainedBy: "Agility-drillar i power-passen (peak)" },
  { id: "squat1rm",  name: "1RM Benböj",        capacity: "Maxstyrka ben",          unit: "kg",        higherIsBetter: true,
    trainedBy: "Tung knäböj — maxstyrkeblock (bygg)" },
  { id: "squatsub",  name: "Submax Benböj",     capacity: "Uthållighetsstyrka",     unit: "reps",      higherIsBetter: true,
    trainedBy: "Submax knäböj 12–15 reps (bas)" },
  { id: "bench1rm",  name: "1RM Bänkpress",     capacity: "Maxstyrka överkropp",    unit: "kg",        higherIsBetter: true,
    trainedBy: "Tung bänkpress — maxstyrkeblock (bygg)" },
  { id: "chins",     name: "Chins",             capacity: "Styrka överkropp",       unit: "reps",      higherIsBetter: true,
    trainedBy: "Chins / viktade chins (alla faser)" },
  { id: "brutalben", name: "Brutalbänk",        capacity: "Bålstyrka",              unit: "reps/tid",  higherIsBetter: true,
    trainedBy: "Ryggresningar / bålpass" },
  { id: "kassehopp", name: "90 sek Kassehopp",  capacity: "Anaerob kapacitet",      unit: "antal hopp", higherIsBetter: true,
    trainedBy: "Boxhopp 90 sek + plyometri (peak)" },
];

export interface EventResult { current?: string; target?: string }
export type IronManResults = Record<string, EventResult>;

const KEY = "ironman-results";

export function loadIronManResults(): IronManResults {
  try { return JSON.parse(localStorage.getItem(KEY) || "{}"); } catch { return {}; }
}

export function saveIronManResult(id: string, field: keyof EventResult, value: string): IronManResults {
  const all = loadIronManResults();
  const next: IronManResults = { ...all, [id]: { ...all[id], [field]: value } };
  try { localStorage.setItem(KEY, JSON.stringify(next)); } catch { /* ignore */ }
  return next;
}
